var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NcDialog',{attrs:{"name":_vm.t('mail', 'Delete mail filter {filterName}?', {filterName: _vm.filter.name}),"open":_vm.open,"message":_vm.t('mail', 'Are you sure to delete the mail filter?'),"buttons":_vm.buttons},on:{"closing":function($event){return _vm.closeModal()}}})
}
var staticRenderFns = []

export { render, staticRenderFns }